export default class Buttons {
	constructor() {
		document.querySelectorAll('.btn-go').forEach((button) => {
			if (button.querySelector('.svg')) return; // SVG déjà présent (rendu Twig)

			const label = document.createElement('span');
			label.classList.add('label');
			while (button.firstChild) {
				label.appendChild(button.firstChild);
			}
			button.appendChild(label);

			const svg = document.createElement('span');
			svg.classList.add('svg');
			svg.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.91763 16L0 14.1126L11.5354 2.57659H0.389333L2.96651 0H16V13.0637L13.453 15.6403V4.46399L1.91763 16Z" fill="#33524D"/>
</svg>
`;
			button.prepend(svg);
		});
	}
}
